const localStorageKey = 'LAST_USER_ACTIVITY';

export const getLastActiveTime = () => {
    const value = localStorage.getItem(localStorageKey);
    return value ? Number(value) : null;
};

export const setLastActiveTime = () => {
    localStorage.setItem(localStorageKey, Date.now().toString());
};

export const markUserSessionAsActive = () => {
    setLastActiveTime();
};

export const clearLastActiveTime = () => {
    localStorage.removeItem(localStorageKey);
};
